import styled from 'styled-components';
import { Row, Col } from 'antd';

export const RowData = styled(Row)`
    display: flex;
    transition: all ease 0.4s;
`;

export const ColData = styled(Col)`
    display: block;
    flex-wrap: wrap;
    margin-right: 12px;
`;

export const DivPhoto = styled.div`
    width: 60px;
    height: 60px;
    border-radius: 12px;
    background-color: #e9ecf2;
    object-fit: cover;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        object-fit: cover;
        border-radius: 8px;
        margin: auto;
        width: 60px;
        height: 60px;
    }
`;

export const DivField = styled.div`
    margin-bottom: 6px;
    display: flex;
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: left;
    color: #262e3e;
`;

export const DivFieldLabel = styled.div`
    font-weight: bold;
    min-width: 60px;
`;

export const DivFieldValue = styled.div`
    margin-left: 6px;
    display: block;
    min-width: 60px;
`;